import Icon from '../../UiKit/icon';

import AchievementSvg from './achievement.svg';
import AttendanceSvg from './attendance.svg';
import AlertOutlineSvg from './alert-outline.svg';
import AlertSvg from './alert.svg';
import ArrowLeftSvg from './arrow-left.svg';
import ArrowRightSvg from './arrow-right.svg';
import AttachmentSvg from './attachment.svg';
import CalendarSvg from './calendar.svg';
import CheckCircleSvg from './check-circle.svg';
import CheckOutlineSvg from './check-outline-icon.svg';
import CheckSvg from './check.svg';
import ChevronDownSvg from './chevron-down.svg';
import ChevronUpSvg from './chevron-up.svg';
import ChevronLeftSvg from './chevron-left.svg';
import ChevronRightSvg from './chevron-right.svg';
import CloseCircleSvg from './close-circle.svg';
import CloseSvg from './close.svg';
import DashboardSvg from './dashboard.svg';
import DownloadSvg from './download.svg';
import ExpandSvg from './expand.svg';
import EyeCloseSvg from './eye-close.svg';
import EyeOpenSvg from './eye-open.svg';
import ExchangeSvg from './exchange.svg';
import LocationSvg from './location.svg';
import MasterDataSvg from './master-data.svg';
import MicrophoneSvg from './microphone.svg';
import OutSvg from './out.svg';
import PencilOutlineSvg from './pencil-outline.svg';
import PlusSvg from './plus.svg';
import SearchOutlineSvg from './search-outline.svg';
import StoreSvg from './store.svg';
import TimeOutlineSvg from './time-outline.svg';
import TrashOutlineSvg from './trash-outline.svg';
import UploadSvg from './upload.svg';
import UserSvg from './user.svg';
import WarningSvg from './warning.svg';
import ExportSvg from './export.svg';
import FileNotesSvg from './file-notes.svg';
import SortSvg from './sort-icon.svg';
import EditSvg from './edit.svg';
import TrashSvg from './trash.svg';
import ChevronFillTop from './chevron-fill-top.svg';
import ChevronFillDown from './chevron-fill-down.svg';
import DoubleChevronLeftSvg from './double-chevron-left.svg';
import DoubleChevronRightSvg from './double-chevron-right.svg';
import HamburgerSvg from './hamburger.svg';
import QuestionMarkSvg from './question-mark.svg';
import RefreshSvg from './refresh-icon.svg';
import NotificationSvg from './notification.svg';
import UserCircleSvg from './user-circle.svg';
import ForkSpoonSvg from './fork-spoon.svg';
import PraySvg from './pray.svg';
import ToiletSvg from './toilet.svg';
import HandShakeSvg from './hand-shake.svg';
import CouponSvg from './coupon.svg';
import HandByeSvg from './hand-bye.svg';
import RedoSvg from './redo.svg';
import StrollerSvg from './stroller.svg';
import CopySvg from './copy.svg';
import HomeSvg from './home.svg';
import HomeFillSvg from './home-fill.svg';
import PromoTagSvg from './promo-tag.svg';
import PromoTagFillSvg from './promo-tag-fill.svg';
import FilterSvg from './filter.svg';
import LoaderSvg from './loader.svg';
import ShoppingBagSvg from './shopping-bag.svg';
import DoubleChevronUpSvg from './double-chevron-up.svg';
import PlusPersonSvg from './plus-person.svg';
import AlarmClockSvg from './alarm-clock.svg';
import CalendarOutlineSvg from './calendar-outline.svg';
import PaperclipSvg from './paperclip.svg';
import StopSvg from './stop.svg';
import PlaySvg from './play.svg';
import PresenceContentSvg from './presence-content.svg';
import PresenceContentFillSvg from './presence-content-fill.svg';
import PlayFillSvg from './play-fill.svg';
import ToolbarBoldSvg from './toolbar-bold.svg';
import ToolbarItalicsSvg from './toolbar-italics.svg';
import ToolbarUnderlineSvg from './toolbar-underline.svg';
import ToolbarStrikeSvg from './toolbar-strike.svg';
import ToolbarLinkSvg from './toolbar-link.svg';
import ToolbarImageSvg from './toolbar-image.svg';
import ToolbarAlignLeftSvg from './toolbar-align-left.svg';
import ToolbarAlignCenterSvg from './toolbar-align-center.svg';
import ToolbarAlignRightSvg from './toolbar-align-right.svg';

export const AchievementIcon = (props) => <Icon {...props} src={AchievementSvg} />;
export const AttendanceIcon = (props) => <Icon {...props} src={AttendanceSvg} />;
export const AlertIcon = (props) => <Icon {...props} src={AlertSvg} />;
export const AlertOutlineIcon = (props) => <Icon {...props} src={AlertOutlineSvg} />;
export const ArrowLeftIcon = (props) => <Icon {...props} src={ArrowLeftSvg} />;
export const ArrowRightIcon = (props) => <Icon {...props} src={ArrowRightSvg} />;
export const AttachmentIcon = (props) => <Icon {...props} src={AttachmentSvg} />;
export const CalendarIcon = (props) => <Icon {...props} src={CalendarSvg} />;
export const CheckCircleIcon = (props) => <Icon {...props} src={CheckCircleSvg} />;
export const CheckOutlineIcon = (props) => <Icon {...props} src={CheckOutlineSvg} />;
export const CheckIcon = (props) => <Icon {...props} src={CheckSvg} />;
export const ChevronDownIcon = (props) => <Icon {...props} src={ChevronDownSvg} />;
export const ChevronUpIcon = (props) => <Icon {...props} src={ChevronUpSvg} />;
export const ChevronLeftIcon = (props) => <Icon {...props} src={ChevronLeftSvg} />;
export const ChevronRightIcon = (props) => <Icon {...props} src={ChevronRightSvg} />;
export const CloseCircleIcon = (props) => <Icon {...props} src={CloseCircleSvg} />;
export const CloseIcon = (props) => <Icon {...props} src={CloseSvg} />;
export const DashboardIcon = (props) => <Icon {...props} src={DashboardSvg} />;
export const DownloadIcon = (props) => <Icon {...props} src={DownloadSvg} />;
export const ExpandIcon = (props) => <Icon {...props} src={ExpandSvg} />;
export const EyeCloseIcon = (props) => <Icon {...props} src={EyeCloseSvg} />;
export const EyeOpenIcon = (props) => <Icon {...props} src={EyeOpenSvg} />;
export const ExchangeIcon = (props) => <Icon {...props} src={ExchangeSvg} />;
export const LocationIcon = (props) => <Icon {...props} src={LocationSvg} />;
export const MasterDataIcon = (props) => <Icon {...props} src={MasterDataSvg} />;
export const MicrophoneIcon = (props) => <Icon {...props} src={MicrophoneSvg} />;
export const OutIcon = (props) => <Icon {...props} src={OutSvg} />;
export const PencilOutlineIcon = (props) => <Icon {...props} src={PencilOutlineSvg} />;
export const PlusIcon = (props) => <Icon {...props} src={PlusSvg} />;
export const SearchOutlineIcon = (props) => <Icon {...props} src={SearchOutlineSvg} />;
export const StoreIcon = (props) => <Icon {...props} src={StoreSvg} />;
export const TimeOutlineIcon = (props) => <Icon {...props} src={TimeOutlineSvg} />;
export const TrashOutlineIcon = (props) => <Icon {...props} src={TrashOutlineSvg} />;
export const UploadIcon = (props) => <Icon {...props} src={UploadSvg} />;
export const UserIcon = (props) => <Icon {...props} src={UserSvg} />;
export const WarningIcon = (props) => <Icon {...props} src={WarningSvg} />;
export const ExportIcon = (props) => <Icon {...props} src={ExportSvg} />;
export const FileNotesIcon = (props) => <Icon {...props} src={FileNotesSvg} />;
export const SortIcon = (props) => <Icon {...props} src={SortSvg} />;
export const EditIcon = (props) => <Icon {...props} src={EditSvg} />;
export const TrashIcon = (props) => <Icon {...props} src={TrashSvg} />;
export const ChevronFillTopIcon = (props) => <Icon {...props} src={ChevronFillTop} />;
export const ChevronFillDownIcon = (props) => <Icon {...props} src={ChevronFillDown} />;
export const DoubleChevronLeftIcon = (props) => <Icon {...props} src={DoubleChevronLeftSvg} />;
export const DoubleChevronRightIcon = (props) => <Icon {...props} src={DoubleChevronRightSvg} />;
export const HamburgerIcon = (props) => <Icon {...props} src={HamburgerSvg} />;
export const QuestionMarkIcon = (props) => <Icon {...props} src={QuestionMarkSvg} />;
export const RefreshIcon = (props) => <Icon {...props} src={RefreshSvg} />;
export const NotificationIcon = (props) => <Icon {...props} src={NotificationSvg} />;
export const UserCircleIcon = (props) => <Icon {...props} src={UserCircleSvg} />;
export const ForkSpoonIcon = (props) => <Icon {...props} src={ForkSpoonSvg} />;
export const PrayIcon = (props) => <Icon {...props} src={PraySvg} />;
export const ToiletIcon = (props) => <Icon {...props} src={ToiletSvg} />;
export const HandShakeIcon = (props) => <Icon {...props} src={HandShakeSvg} />;
export const CouponIcon = (props) => <Icon {...props} src={CouponSvg} />;
export const HandByeIcon = (props) => <Icon {...props} src={HandByeSvg} />;
export const RedoIcon = (props) => <Icon {...props} src={RedoSvg} />;
export const StrollerIcon = (props) => <Icon {...props} src={StrollerSvg} />;
export const CopyIcon = (props) => <Icon {...props} src={CopySvg} />;
export const HomeIcon = (props) => <Icon {...props} src={HomeSvg} />;
export const HomeFillIcon = (props) => <Icon {...props} src={HomeFillSvg} />;
export const PromoTagIcon = (props) => <Icon {...props} src={PromoTagSvg} />;
export const PromoTagFillIcon = (props) => <Icon {...props} src={PromoTagFillSvg} />;
export const FilterIcon = (props) => <Icon {...props} src={FilterSvg} />;
export const LoaderIcon = (props) => <Icon {...props} src={LoaderSvg} />;
export const ShoppingBagIcon = (props) => <Icon {...props} src={ShoppingBagSvg} />;
export const DoubleChevronUpIcon = (props) => <Icon {...props} src={DoubleChevronUpSvg} />;
export const PlusPersonIcon = (props) => <Icon {...props} src={PlusPersonSvg} />;
export const AlarmClockIcon = (props) => <Icon {...props} src={AlarmClockSvg} />;
export const CalendarOutlineIcon = (props) => <Icon {...props} src={CalendarOutlineSvg} />;
export const PaperclipIcon = (props) => <Icon {...props} src={PaperclipSvg} />;
export const StopIcon = (props) => <Icon {...props} src={StopSvg} />;
export const PlayIcon = (props) => <Icon {...props} src={PlaySvg} />;
export const PresenceContentIcon = (props) => <Icon {...props} src={PresenceContentSvg} />;
export const PresenceContentFillIcon = (props) => <Icon {...props} src={PresenceContentFillSvg} />;
export const PlayFillIcon = (props) => <Icon {...props} src={PlayFillSvg} />;
export const ToolbarBoldIcon = (props) => <Icon {...props} src={ToolbarBoldSvg} />;
export const ToolbarItalicsIcon = (props) => <Icon {...props} src={ToolbarItalicsSvg} />;
export const ToolbarUnderlineIcon = (props) => <Icon {...props} src={ToolbarUnderlineSvg} />;
export const ToolbarStrikeIcon = (props) => <Icon {...props} src={ToolbarStrikeSvg} />;
export const ToolbarLinkIcon = (props) => <Icon {...props} src={ToolbarLinkSvg} />;
export const ToolbarImageIcon = (props) => <Icon {...props} src={ToolbarImageSvg} />;
export const ToolbarAlignLeftIcon = (props) => <Icon {...props} src={ToolbarAlignLeftSvg} />;
export const ToolbarAlignCenterIcon = (props) => <Icon {...props} src={ToolbarAlignCenterSvg} />;
export const ToolbarAlignRightIcon = (props) => <Icon {...props} src={ToolbarAlignRightSvg} />;
